import { Nullable } from '@clearverify/types';

import {
  DataDisputeInfoFragment,
  DataDisputeItemInfoFragment,
  DataDisputeItemStatus,
  DataDisputeItemWhere,
} from 'src/api';
import { UserPermissions } from 'src/constants/user';

import { DataDisputeVRConnectionStatus } from './types';

export const checkDataDisputeVerificationRequestStatus = (
  dataDispute: Nullable<
    DataDisputeInfoFragment & { dataDisputeItemsList: DataDisputeItemInfoFragment[] }
  >,
): DataDisputeVRConnectionStatus => {
  const isDataDisputeResolved = dataDispute?.dataDisputeItemsList.every(
    dataDisputeItem => dataDisputeItem.status === DataDisputeItemStatus.Resolved,
  );

  const isDataDisputeConnected = Boolean(dataDispute?.verificationRequest);

  if (isDataDisputeResolved) {
    if (isDataDisputeConnected) {
      return DataDisputeVRConnectionStatus.resolvedWithConnect;
    }

    return DataDisputeVRConnectionStatus.resolvedNoConnect;
  }

  if (isDataDisputeConnected) {
    return DataDisputeVRConnectionStatus.pendingWithConnect;
  }

  return DataDisputeVRConnectionStatus.pendingNoConnect;
};

export const getDataDisputeEmployerFilter = (
  user: Nullable<{ id: string }>,
  employer: Nullable<{ id: string }>,
  peo: Nullable<{ id: string }>,
  peoPayrollProvider: Nullable<{ id: string }>,
  userPermissions: UserPermissions,
): DataDisputeItemWhere => {
  const { hasEmployerRoles, hasPeoRoles, isPeoPayrollProviderUser } = userPermissions;

  return {
    OR: [
      ...(hasEmployerRoles ? [{ employerId: { equals: employer?.id } }] : []),
      ...(hasPeoRoles ? [{ employer: { peoId: { equals: peo?.id } } }] : []),
      ...(isPeoPayrollProviderUser
        ? [
            {
              OR: [
                { employer: { peoPayrollProviderId: { equals: peoPayrollProvider?.id } } },
                { employer: { peo: { peoPayrollProviderId: { equals: peoPayrollProvider?.id } } } },
              ],
            },
          ]
        : []),
    ],
  };
};
